import clsApiPost from '@cls/clsApiPost'

class clsSalesOrder extends clsApiPost {

    loadStats() {
        return this.post(`stats`); 
    }

    async createInvoice(id_order,  line_ids, ) {
        return this.post('createinvoice', {id_order: id_order, lines: line_ids})
    }
    async pdf(id, lineids) {
        return this.post('createpdf', {id: id, lineids: lineids})
    }

    async merge(model) {
        return this.post('merge', model)
    }

}

export default clsSalesOrder;
